const screen = {
    isOnScreen(element) {
        let $this = $(element);
        if ($this.length === 0) {
            return false;
        }
        let viewport    = {};
        viewport.top    = $(window).scrollTop();
        viewport.bottom = viewport.top + $(window).height();
        let bounds      = {};
        bounds.top      = $this.offset().top;
        bounds.bottom   = bounds.top + $this.outerHeight();
        return ((bounds.bottom <= viewport.bottom) && (bounds.top >= viewport.top));
    },
    isPartiallyOnScreen(element) {
        let $this = $(element);
        if ($this.length === 0) {
            return false;
        }
        let viewport    = {};
        viewport.top    = $(window).scrollTop();
        viewport.bottom = viewport.top + $(window).height();
        let bounds      = {};
        bounds.top      = $this.offset().top;
        bounds.bottom   = bounds.top + $this.outerHeight();
        return (((bounds.bottom > viewport.top) && (bounds.top < viewport.bottom)) || ((bounds.top < viewport.bottom) && (bounds.bottom
                > viewport.top)));
    }
};

export default screen;
